// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper___-p5j","tab":"Tabs_tab__24TkR","disabled":"Tabs_disabled__1tMpI","current":"Tabs_current__SUJJu"};